var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 53,
    viewBox: "0 0 105 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 53H24.3813V0H0V53Z",
    fill: "#0082C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3763 36.5132L14.527 26.0367L21.8731 16.7207H15.5458L8.88241 25.3483V16.7207H3.50684V36.5132H8.88241V27.1344L15.798 36.5132H22.3763Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6162 53H77.9989V0H53.6162V53Z",
    fill: "#0082C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7884 16.7207V26.3853L59.9232 16.7207H56.8389V36.5132H61.8197V26.4713L72.0657 36.5132H74.786V16.7207H69.7884Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8164 53H51.1978V0H26.8164V53Z",
    fill: "#0082C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.007 16.1484C33.2058 16.1484 28.5493 20.3557 28.5493 26.4769C28.5493 32.6092 33.2058 36.8137 39.007 36.8137C44.7962 36.8137 49.4668 32.6092 49.4668 26.4769C49.4668 20.3557 44.7962 16.1484 39.007 16.1484ZM44.0821 26.4769C44.0821 29.8387 41.8608 32.1467 39.007 32.1467C36.1449 32.1467 33.92 29.8387 33.92 26.4769C33.92 23.1277 36.1449 20.819 39.007 20.819C41.8608 20.819 44.0821 23.1277 44.0821 26.4769Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4331 53H104.766V0H80.4331V53Z",
    fill: "#0082C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3656 32.0237V28.6626H99.1093V24.433H90.3656V21.0887H100.321V16.7207H85.0605V36.5132H100.321V32.0237H90.3656Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKone);
export default __webpack_public_path__ + "static/media/kone.dd9c67f2a1149da4f3ba9fa4d0ff66b6.svg";
export { ForwardRef as ReactComponent };